import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import { useReduxSelector } from "@hooks/useReduxSelector";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";

export const useSectionSecurityColumns = () => {
  const { t } = useTranslation("pages.employés.emploi&Salary");

  return useMemo(() => [
    { id: "permission", label: t("Permissions*") },
    { id: "accessProfile", label: t("Profil d'accès") }
  ], [t])
}

export const SectionSecurityTableBulkHeader = ({ hiddenColumns = {} }) => {
  const { t: mainTranslator } = useTranslation("pages.employés.emploi&Salary");

  return (
    <>
      <th
        key="permission"
        className={`arh-w-[15.625rem] arh-min-w-[15.625rem] arh-max-w-[15.625rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.permission ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Permissions*")}
      </th>
      <th
        key="accessProfile"
        className={`arh-w-[15.625rem] arh-min-w-[15.625rem] arh-max-w-[15.625rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.accessProfile ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Profil d'accès")}
      </th>
    </>
  );
};

export const SectionSecurityTableBulkCells = ({
  control,
  employeeIndex,
  employee,
  permissionsList = [],
  readOnly = false,
  mustWait = false,
  isLastAdmin = false,
  hiddenColumns = {},
}) => {
  const { t: mainTranslator } = useTranslation("pages.employés.emploi&Salary");
  const accessProfiles = useReduxSelector(({ settings }) => settings.accessProfiles.list || []);
  const defaultAccessProfile = employee.accessProfileCustomised && !employee.accessProfile
    ? { _id: null, title: mainTranslator("Custom") }
    : employee.accessProfile || null;

  return (
    <>
      <td
        key="permission"
        className={`arh-w-[15.625rem] arh-min-w-[15.625rem] arh-max-w-[15.625rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor arh-ml-[1rem] ${hiddenColumns.permission ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.Permission`}
          defaultValue={employee.emploiSalary?.Permission || ""}
          render={({ field: { onChange, value }, fieldState: { invalid } }) => (
            <ListboxSimple
              name={`employees.${employeeIndex}.emploiSalary.Permission`}
              placeholder={mainTranslator("Permissions*")}
              optionList={permissionsList}
              optionTextAttribut="role"
              selectedValue={value}
              setSelectedValue={onChange}
              readOnly={mustWait || isLastAdmin || readOnly}
              customButtonClass="!arh-py-[5px] !arh-px-2.5 !arh-pr-8 arh-truncate arh-whitespace-nowrap arh-overflow-hidden"
              invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="accessProfile"
        className={`arh-w-[15.625rem] arh-min-w-[15.625rem] arh-max-w-[15.625rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor arh-ml-[1rem] ${hiddenColumns.accessProfile ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.accessProfile`}
          defaultValue={defaultAccessProfile}
          render={({ field: { onChange, value }, fieldState: { invalid } }) => (
            <ListboxSimple
              name={`employees.${employeeIndex}.accessProfile`}
              placeholder={mainTranslator("Profil d'accès")}
              optionList={accessProfiles}
              optionTextAttribut="title"
              selectedValue={value}
              setSelectedValue={onChange}
              readOnly={mustWait || isLastAdmin || readOnly}
              customButtonClass="!arh-py-[5px] !arh-px-2.5 !arh-pr-8 arh-truncate arh-whitespace-nowrap arh-overflow-hidden"
              noRadio
              invalid={invalid}
            />
          )}
        />
      </td>
    </>
  );
};
export const getJobColumnCount = () => 2